module.exports = __webpack_public_path__ + "static/media/dolphin-logo-white.1d0a8416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dolphin-logo-white.png
// module id = 1332
// module chunks = 1